










































































import Vue from 'vue'
import { negate as skip, orderBy } from 'lodash'
import { mapGetters, mapActions } from 'vuex'
import store from '@/store'

import OfferDisplay from '@/components/interviews/Offer.vue'
import RescheduleModal from './manage/RescheduleModal.vue'
import CreateModal from './manage/CreateModal.vue'
import ErrorModal from './manage/ErrorModal.vue'
import Calendar from './Calendar.vue'

import { Action, Mutation } from '@/store/interview'
import { Offer } from '@/store/interview/offers/types'

const isBooked = (slot: Offer) => slot!.activeBookings.nodes.length > 0

const isAvailable = (slot: Offer) => !isBooked(slot)

const hasTakenPlace = (slot: Offer) => slot!.hasTakenPlace === true

const hasBeenMissed = (slot: Offer) => !hasTakenPlace(slot)

const isCanceled = (slot: Offer) => !isBooked(slot) && slot!.canceledBookings.nodes.length > 0

const isRecorded = (slot: Offer) =>
  hasTakenPlace(slot) &&
  slot!.activeBookings.nodes.some(
    b =>
      !!store.getters['interviewReports/findBy']({ case_id: b.caseId }) ||
      !!store.getters['feedbackInterviewReports/findBy']({ case_id: b.caseId })
  )

const isUnrecorded = (slot: Offer) => !isRecorded(slot)

const returnTrue = () => true

export default Vue.extend({
  components: {
    Calendar,
    Offer: OfferDisplay,
    CreateModal,
    ErrorModal,
    RescheduleModal,
  },
  computed: {
    ...mapGetters('interview/offers', {
      canceled: 'canceled',
      adoptible: 'adoptible',
    }),
    allUpcoming(): Offer[] {
      return this.$store.getters['interview/offers/upcoming'].filter(o => !hasTakenPlace(o))
    },
    upcoming(): Offer[] {
      return this.allUpcoming.filter(
        slot =>
          (this.show.available && isAvailable(slot)) ||
          (this.show.booked && isBooked(slot)) ||
          (this.show.canceled && isCanceled(slot))
      )
    },
    countAvailable(): number {
      return this.countUpcoming(isAvailable)
    },
    countBooked(): number {
      return this.countUpcoming(isBooked)
    },
    countCanceled(): number {
      return this.countUpcoming(isCanceled)
    },
    countMissed(): number {
      return this.countPast(hasBeenMissed)
    },
    countHasTakenPlace(): number {
      return this.countPast(hasTakenPlace)
    },
    countUnrecorded(): number {
      return this.countPast(isUnrecorded)
    },
    allPresent(): Offer[] {
      return this.$store.getters['interview/offers/present'].filter(
        o => !isCanceled(o) && !hasTakenPlace(o)
      )
    },
    present(): Offer[] {
      return this.allPresent.filter(o => true)
    },
    allPast(): Offer[] {
      return orderBy(
        [
          ...this.$store.getters['interview/offers/upcoming'].filter(o => hasTakenPlace(o)),
          ...this.$store.getters['interview/offers/present'].filter(
            o => isCanceled(o) || hasTakenPlace(o)
          ),
          ...this.$store.getters['interview/offers/past'],
        ],
        'timeSlot.start.value',
        'desc'
      )
    },
    past(): Offer[] {
      return this.allPast.filter(
        offer =>
          (this.show.hasTakenPlace && hasTakenPlace(offer)) ||
          (this.show.missed && hasBeenMissed(offer)) ||
          (this.show.unrecorded && isUnrecorded(offer))
      )
    },
    editableOffer: {
      get(): Offer {
        const edit = this.$store.getters['interview/offers/editOffer']
        return edit && edit.withIntent === 'reschedule' && edit.editObject
      },
      set(offer: Offer | null) {
        if (offer === null) {
          this.$store.commit({
            type: 'interview/offers/stopToEdit',
          })
        } else {
          this.$store.commit({
            type: 'interview/offers/selectToEdit',
            offer,
            withIntent: 'reschedule',
          })
        }
      },
    },
  },
  created() {
    this.refreshList()
    this.refreshInterval = window.setInterval(() => this.refreshList(), 60 * 1000)
  },
  data() {
    return {
      refreshInterval: 0,
      show: {
        available: true,
        booked: true,
        canceled: true,
        hasTakenPlace: true,
        missed: true,
        unrecorded: true,
      },
    }
  },
  beforeDestroy() {
    window.clearInterval(this.refreshInterval)
  },
  methods: {
    countUpcoming(predicate: (slot: Offer) => boolean): number {
      return this.allUpcoming.filter(predicate).length - this.upcoming.filter(predicate).length
    },
    countPast(predicate: (slot: Offer) => boolean): number {
      return this.allPast.filter(predicate).length - this.past.filter(predicate).length
    },
    refreshList(): void {
      this.$store.dispatch({ type: 'interview/fetch' })
    },
  },
  watch: {
    $route: 'refreshList',
  },
})
